import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=7f6f2676&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6f2676')) {
      api.createRecord('7f6f2676', component.options)
    } else {
      api.reload('7f6f2676', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=7f6f2676&", function () {
      api.rerender('7f6f2676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21l0gCnLvYxnO/JS/pricehelp.vue"
export default component.exports